import type { SiteConfig, NavLink } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Nuvéa',
    wordmark: 'Nuvéa',
    description: 'One jar. Five actives that earn their place. Nuvéa is skincare edited down to what your skin actually uses, and nothing it has to work around.',
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: getOrigin(),
    email: 'hello@nuvea.com',
    phone: '(555) 204-8890',
    phoneHref: 'tel:+15552048890',
    address: '9 Rue de Sèvres, 75006 Paris',
    establishedIn: '2021',
    madeIn: 'Switzerland',
    links: {
        instagram: 'https://instagram.com/',
        twitter: 'https://x.com/',
        tiktok: 'https://tiktok.com/'
    }
}

export const navLinks: NavLink[] = [
    { label: 'Shop', href: '/shop' },
    { label: 'About', href: '/about' },
    { label: 'Journal', href: '/journal' },
    { label: 'Support', href: '/support' }
]

export const footerSocials: NavLink[] = [
    { label: 'Instagram', href: siteConfig.links.instagram },
    { label: 'X / Twitter', href: siteConfig.links.twitter },
    { label: 'Tiktok', href: siteConfig.links.tiktok }
]

export const footerLegal: NavLink[] = [
    { label: 'Terms & Conditions', href: '/terms' },
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Payment Methods', href: '/payment-methods' }
]

export const orderAnchor = '/shop'
